/* eslint-disable no-nested-ternary */
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import CustomButton from '../../shared/CustomButton';

const useStyles = makeStyles({
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    background: 'white',
    padding: '10px',
    zIndex: 10,
  },
});

const PopupFooter = ({ add = true, step, backBtn, saveContest, totalSteps = 3 }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justifyContent="flex-end"
      alignItems="center"
      className={classes.stickyFooter}
      style={{ padding: '10px' }}
    >
      <Grid item>
        <CustomButton
          label="Back"
          variant="contained"
          size="small"
          type="secondary"
          onClick={backBtn}
          disabled={step === 1}
        />
      </Grid>
      <Grid item style={{ marginLeft: '10px' }}>
        <CustomButton
          label={step !== totalSteps ? 'Next' : add ? 'Add' : 'Update'}
          variant="contained"
          size="small"
          type="primary"
          onClick={saveContest}
        />
      </Grid>
    </Grid>
  );
};

export default PopupFooter;
